// extracted by mini-css-extract-plugin
export default {"footer":"GuidesPage_footer__4HiH0","cards":"GuidesPage_cards__KkcRn","card":"GuidesPage_card__sQpak","subtitle":"GuidesPage_subtitle__Ynrih"};